import { isTokenValid, readProfile } from '../../utils/authUtils';
import * as api from '../api/authApi';
import * as types from '../constants/authConstants';
import { hydrateAndDispatch } from './authHelpers';
import { refreshTokenAction } from './refreshTokenAction';

export const initializeAuth = () => async (dispatch) => {
  const accessToken = readProfile()?.accessToken;
  if (!accessToken) return;
  if (isTokenValid(accessToken)) {
    try {
      await hydrateAndDispatch(dispatch, accessToken);
    } catch (_) {
      await dispatch(refreshTokenAction());
    }
  } else {
    await dispatch(refreshTokenAction());
  }
};

export const setInitialAuthState = (navigate) => async (dispatch) => {
  await dispatch({ type: types.LOGOUT });
  navigate('/login');
};

export const logoutAction = () => async (dispatch) => {
  await api.logout();
  await dispatch({ type: types.LOGOUT });
  localStorage.removeItem('profile');
};

export const loginAction = (credentials, navigate) => async (dispatch) => {
  try {
    const response = await api.login(credentials);
    if (response.error) {
      dispatch({ type: types.AUTHORIZATION_FAIL, payload: types.UNAUTHORIZED_MESSAGE });
      return;
    }
    const { access_token } = response.data;
    await hydrateAndDispatch(dispatch, access_token);
    navigate('/');
  } catch (error) {
    await dispatch({ type: types.AUTHORIZATION_FAIL, payload: types.SERVER_ERROR_MESSAGE });
    navigate('/login');
  }
};
